import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2c72647a")

_pushScopeId("data-v-2c72647a")
const _hoisted_1 = { id: "aov_custom_report" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { id: "header" }, [
  /*#__PURE__*/_createVNode("h1", null, "AOV-Trunk线性能监控测试报告")
], -1)
const _hoisted_3 = { id: "section" }
const _hoisted_4 = { class: "choiceDiv spacName" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("复制数据")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("查询")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("发送邮件")
const _hoisted_8 = /*#__PURE__*/_createVNode("h6", null, "一、最近两轮详细数据：", -1)
const _hoisted_9 = { class: "popover-Div" }
const _hoisted_10 = /*#__PURE__*/_createVNode("p", { class: "el-icon-info" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("h6", null, "二、性能指标趋势图：", -1)
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_popover = _resolveComponent("el-popover")
  const _component_el_card = _resolveComponent("el-card")
  const _component_el_empty = _resolveComponent("el-empty")
  const _component_el_main = _resolveComponent("el-main")
  const _component_el_container = _resolveComponent("el-container")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock(_component_el_container, null, {
    default: _withId(() => [
      _createVNode(_component_el_container, null, {
        default: _withId(() => [
          _createVNode(_component_el_main, null, {
            default: _withId(() => [
              _createVNode("div", _hoisted_1, [
                _createVNode(_component_el_card, { style: {"width":"85%","margin":"0 auto"} }, {
                  default: _withId(() => [
                    _hoisted_2,
                    _createVNode("div", _hoisted_3, [
                      _createVNode("div", _hoisted_4, [
                        _createVNode(_component_el_form, {
                          inline: true,
                          model: _ctx.copyVal,
                          class: "demo-form-inline",
                          size: "mini"
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_form_item, { label: "任务记录id" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_select, {
                                  onChange: _ctx.equipmentUpdate,
                                  modelValue: _ctx.copyVal.taskRecordId,
                                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.copyVal.taskRecordId = $event)),
                                  placeholder: "请选择任务记录id",
                                  filterable: ""
                                }, {
                                  default: _withId(() => [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.TaskRecordQuery, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: item.id,
                                        label: item.id,
                                        value: item.id
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["onChange", "modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, { label: "设备数据" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_select, {
                                  modelValue: _ctx.copyVal.deviceVal,
                                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.copyVal.deviceVal = $event)),
                                  placeholder: "请选择设备数据",
                                  filterable: ""
                                }, {
                                  default: _withId(() => [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.TaskRecordDevices, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: item.id,
                                        label: item.model.model,
                                        value: item.id
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, null, {
                              default: _withId(() => [
                                _createVNode(_component_el_popconfirm, {
                                  title: "确认复制数据吗？",
                                  onConfirm: _ctx.CopyBtn,
                                  placement: "top"
                                }, {
                                  reference: _withId(() => [
                                    _createVNode(_component_el_button, {
                                      type: "primary",
                                      disabled: _ctx.interfaceDisabled
                                    }, {
                                      default: _withId(() => [
                                        _hoisted_5
                                      ]),
                                      _: 1
                                    }, 8, ["disabled"])
                                  ]),
                                  _: 1
                                }, 8, ["onConfirm"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["model"]),
                        _createVNode(_component_el_form, {
                          inline: true,
                          model: _ctx.mustVal,
                          class: "demo-form-inline",
                          size: "mini"
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_form_item, { label: "任务记录id" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_select, {
                                  onChange: _ctx.RecordIdUpdate,
                                  modelValue: _ctx.mustVal.taskRecordId,
                                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.mustVal.taskRecordId = $event)),
                                  placeholder: "请选择任务记录id",
                                  filterable: ""
                                }, {
                                  default: _withId(() => [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.RecentTaskrecord, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: item.value,
                                        label: item.label,
                                        value: item.value
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["onChange", "modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, { label: "最近几轮数据" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: _ctx.mustVal.Interval,
                                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.mustVal.Interval = $event)),
                                  placeholder: "请输入最近几轮数据"
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, null, {
                              default: _withId(() => [
                                _createVNode(_component_el_button, {
                                  type: "primary",
                                  onClick: _ctx.onSubmit
                                }, {
                                  default: _withId(() => [
                                    _hoisted_6
                                  ]),
                                  _: 1
                                }, 8, ["onClick"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, null, {
                              default: _withId(() => [
                                _createVNode(_component_el_popconfirm, {
                                  title: "确认发送邮件吗？",
                                  onConfirm: _ctx.Sendout,
                                  placement: "top"
                                }, {
                                  reference: _withId(() => [
                                    _createVNode(_component_el_button, {
                                      type: "success",
                                      disabled: _ctx.get_is_super
                                    }, {
                                      default: _withId(() => [
                                        _hoisted_7
                                      ]),
                                      _: 1
                                    }, 8, ["disabled"])
                                  ]),
                                  _: 1
                                }, 8, ["onConfirm"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["model"])
                      ]),
                      _hoisted_8,
                      _createVNode(_component_el_card, { class: "spacName" }, {
                        default: _withId(() => [
                          _createVNode(_component_el_popover, {
                            effect: "light",
                            trigger: "hover",
                            placement: "left",
                            width: 170
                          }, {
                            default: _withId(() => [
                              _createVNode("div", _hoisted_9, [
                                _hoisted_10,
                                _createVNode("p", null, "任务记录id：" + _toDisplayString(_ctx.Tips), 1)
                              ])
                            ]),
                            reference: _withId(() => [
                              _withDirectives(_createVNode(_component_el_table, {
                                data: _ctx.get_all_performance,
                                size: "mini",
                                "max-height": "800",
                                "row-style": _ctx.TableRowStyle,
                                onCellMouseEnter: _ctx.handleMouseEnter,
                                "header-cell-class-name": "tabelHeader"
                              }, {
                                default: _withId(() => [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.PerfFields, (item, index) => {
                                    return (_openBlock(), _createBlock(_component_el_table_column, {
                                      key: item.label,
                                      index: index,
                                      label: item.label,
                                      prop: item.label,
                                      title: item.label,
                                      "show-overflow-tooltip": true,
                                      align: "center",
                                      width: item.width,
                                      fixed: item.fixed
                                    }, null, 8, ["index", "label", "prop", "title", "width", "fixed"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["data", "row-style", "onCellMouseEnter"]), [
                                [_directive_loading, _ctx.loading]
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _hoisted_11,
                      (_ctx.PerformanceAovTrend.length !== 0)
                        ? (_openBlock(), _createBlock("div", _hoisted_12, [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.PerformanceAovTrend, (item, index) => {
                              return _withDirectives((_openBlock(), _createBlock(_component_el_card, {
                                key: index,
                                class: "spacName2"
                              }, {
                                default: _withId(() => [
                                  _createVNode("div", {
                                    id: 'Performance_trends' + index,
                                    style: {"height":"600px"}
                                  }, null, 8, ["id"])
                                ]),
                                _: 2
                              }, 1536)), [
                                [_directive_loading, _ctx.loading]
                              ])
                            }), 128))
                          ]))
                        : (_openBlock(), _createBlock("div", _hoisted_13, [
                            _createVNode(_component_el_card, { class: "spacName2" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_empty, { "image-size": 200 })
                              ]),
                              _: 1
                            })
                          ]))
                    ])
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})